<template>
  <div>
    <div class="animated fadeIn">
      <loading
        :active.sync="isLoading"
        :can-cancel="false"
        :is-full-page="true"
      />
    </div>
    <b-col cols="12">
      <transition name="slide">
        <b-card>
          <b-col cols="12">
            <span class="f-g">
              <p class="font-weight-bold">
                Detalhes do cliente: {{ this.idDetalheCliente }} -
                {{ this.nomeDetalheCliente }} {{ this.sobrenomeDetalheCliente }}
              </p>
            </span>
            <b-form-group
              label="Dados de endereço"
              label-class="font-weight-bold pt-0"
            >
              <b-table
                id="Addresses"
                hover
                striped
                bordered
                stickyColumn
                responsive
                :items="detailsAddressesClient"
                :fields="fieldsAddressesClient"
                :current-page="currentPage"
                :per-page="perPage"
                head-variant="light"
              >
              </b-table>
            </b-form-group>
            <b-row>
              <b-col cols="6">
                <b-form-group
                  label="Dados de dispositivo"
                  label-class="font-weight-bold pt-0"
                >
                  <b-table
                    id="Devices"
                    hover
                    striped
                    bordered
                    stickyColumn
                    responsive
                    :items="detailsDevicesClient"
                    :fields="fieldsDevicesClient"
                    :current-page="currentPage"
                    :per-page="perPage"
                    head-variant="light"
                  >
                    <template v-slot:cell(islive)="data">
                      <b-badge v-if="data.item.islive == 0" variant="danger">
                        {{ data.item.islive == 0 ? "Não" : "Sim" }}
                      </b-badge>
                      <b-badge v-else variant="success">
                        {{ data.item.islive == 0 ? "Não" : "Sim" }}
                      </b-badge>
                    </template>
                  </b-table>
                </b-form-group>
              </b-col>

              <b-col cols="6">
                <b-form-group
                  label="Dados de celular"
                  label-class="font-weight-bold pt-0"
                >
                  <b-table
                    id="Devices"
                    hover
                    striped
                    bordered
                    stickyColumn
                    responsive
                    :items="detailsPhonesClient"
                    :fields="fieldsPhonesClient"
                    :current-page="currentPage"
                    :per-page="perPage"
                    head-variant="light"
                  >
                    <template v-slot:cell(islive)="data">
                      <b-badge
                        v-if="data.item.islive == false"
                        variant="success"
                      >
                        {{ data.item.ativo == false ? "Não" : "Sim" }}
                      </b-badge>
                      <b-badge v-else variant="danger">
                        {{ data.item.islive == false ? "Não" : "Sim" }}
                      </b-badge>
                    </template>
                  </b-table>
                </b-form-group>
              </b-col>
            </b-row>

            <b-form-group
              label="Dados de e-mail"
              label-class="font-weight-bold pt-0"
            >
              <b-table
                id="Devices"
                hover
                striped
                bordered
                stickyColumn
                responsive
                :items="detailsEmailsClient"
                :fields="fieldsEmailsClient"
                :current-page="currentPage"
                :per-page="perPage"
                head-variant="light"
              >
              </b-table>
            </b-form-group>
          </b-col>
          <div>
            <b-button
              variant="danger"
              class="my-2 my-sm-0 mr-sm-2 w100"
              type="submit"
              @click="goBack"
            >
              <i class="fa fa-arrow-left"></i>
              Voltar
            </b-button>
          </div>
        </b-card>
      </transition>
    </b-col>
  </div>
</template>
<script>
import Loading from "vue-loading-overlay";

import axios from "axios";
import * as config from "@/config.json";
export default {
  name: "DetalheCliente",
  components: { Loading },
  data: () => {
    return {
      isLoading: false,
      idDetalheCliente: null,
      nomeDetalheCliente: null,
      sobrenomeDetalheCliente: null,

      perPage: 12,
      currentPage: 1,

      detailsAddressesClient: [],

      fieldsAddressesClient: [
        { key: "address", label: "Endereço" },
        { key: "number", label: "Número" },
        { key: "zipCode", label: "CEP" },
        { key: "neighborhood", label: "Bairro" },
        { key: "city", label: "Cidade" },
        { key: "state", label: "UF" },
        { key: "type", label: "Tipo" },
        { key: "additional", label: "Complemento" },
        { key: "notes", label: "Observação" },
      ],

      detailsDevicesClient: [],
      fieldsDevicesClient: [
        { key: "name", label: "Nome" },
        { key: "islive", label: "Ativo" },
      ],

      detailsPhonesClient: [],
      fieldsPhonesClient: [
        { key: "number", label: "Número" },
        { key: "type", label: "Tipo" },
      ],

      detailsEmailsClient: [],
      fieldsEmailsClient: [
        { key: "email", label: "E-mail" },
        { key: "type", label: "Tipo" },
      ],
    };
  },

  methods: {
    goBack() {
      localStorage.removeItem("idDetalheCliente");
      localStorage.removeItem("nomeDetalheCliente");
      localStorage.removeItem("sobrenomeDetalheCliente");

      this.isLoading = false;
      this.$router.go(-1);
    },
    buildParamsClient(companyId, customerId) {
      return {
        companyId: companyId,
        customerId: customerId,
      };
    },
    async retornaDetalhesCliente(id) {
      this.isLoading = true;
      const url = `${config.default.servidor}/gerencial/cliente/detalhes`;

      const params = this.buildParamsClient(
        localStorage.getItem("enterprise_id"),
        id
      );

      try {
        const response = await axios({
          url,
          method: "get",
          params,
          headers: { authorization: config.default.authorizationBasic },
        });

        if (response.status == 200) {
          this.detailsAddressesClient = response.data.addresses;
          this.detailsDevicesClient = response.data.devices;
          this.detailsEmailsClient = response.data.emails;
          this.detailsPhonesClient = response.data.phones;

          this.isLoading = false;
        }
      } catch (error) {
        this.isLoading = false;
        console.log({ error });
      }
    },
  },

  async beforeMount() {
    this.idDetalheCliente = localStorage.getItem("idDetalheCliente");
    this.nomeDetalheCliente = localStorage.getItem("nomeDetalheCliente");
    this.sobrenomeDetalheCliente = localStorage.getItem(
      "sobrenomeDetalheCliente"
    );
    await this.retornaDetalhesCliente(this.idDetalheCliente);
  },
};
</script>